// @flow

import type { PendingIncomingPayment } from './types';
import { getGateway } from '@tectonics/prs/gateway';

export function getGatewayUssdCode(incomingPayment: PendingIncomingPayment): ?string {
  const gateway = getGateway(incomingPayment);
  return gateway['ussd_code'];
}

export function getSafeGatewayUssdCode(incomingPayment: PendingIncomingPayment): string {
  const code = getGatewayUssdCode(incomingPayment);
  if (!code) {
    throw new Error('getSafeGatewayUssdCode - there is no ussd code in the incoming payment');
  }
  return code;
}
